module.exports = __webpack_public_path__ + "img/StudentsOnly_Networking.a8e8b534.png";